import { ContextModalProvider, Flex, useDevice } from '@ergolabs/ui-kit';
import { DateTime, Interval } from 'luxon';
import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

import { useIdoInfo } from './common/hooks/useIdoInfo';
import { useObservable } from './common/hooks/useObservable';
import { ergoWasm$ } from './common/services/ergoWasm';
import { startAppTicks } from './common/streams/appTick';
import { device } from './common/utils/size';
import { ClaimTable } from './components/ClaimTable/ClaimTable';
import { Glow } from './components/Grow/Grow';
import { Header } from './components/Header/Header';
import { KycListener } from './components/KycListener/KycListener';
import { RoundForm } from './components/RoundForm/RoundForm';
import { RoundInfo } from './components/RoundInfo/RoundInfo';
import StartTimer from './components/StartTimer/StartTimer';
import { Timeline } from './components/Timeline/Timeline';
import { Title } from './components/Title/Title';

const Container = styled(Flex)`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  width: 100%;

  ${device.m} {
    padding: 0 1.5rem;
  }

  ${device.l} {
    padding: 0 2rem;
  }
`;

const Content = styled(Flex)`
  width: 100%;
  max-width: 1156px;
  margin: 0 auto;
`;

export const App: FC = () => {
  const { valBySize, s } = useDevice();
  const [applicationReady] = useObservable(ergoWasm$);
  const idoInfo = useIdoInfo();

  useEffect(() => {
    if (applicationReady) {
      startAppTicks();
    }
  }, [applicationReady]);

  const showWhiteListTimer = Interval.fromDateTimes(
    DateTime.utc(2023, 2, 7, 20, 0),
    DateTime.utc(2023, 2, 15, 6, 0),
  ).contains(DateTime.now());

  return (
    <>
      {applicationReady && (
        //@ts-ignore
        <ContextModalProvider>
          <Container col>
            <KycListener />
            <Glow />
            <Flex.Item>
              <Header />
            </Flex.Item>

            {showWhiteListTimer ? (
              <StartTimer />
            ) : (
              <Content col>
                <Flex.Item marginBottom={valBySize(4, 4, 0)} width="100%">
                  <Title isClaim={idoInfo.ended} />
                </Flex.Item>

                {idoInfo.ended ? (
                  <Flex.Item>
                    <ClaimTable />
                  </Flex.Item>
                ) : (
                  <>
                    {' '}
                    <Flex.Item width="100%" marginBottom={valBySize(4, 4, 6)}>
                      <Timeline />
                    </Flex.Item>
                    <Flex.Item width="100%" marginBottom={20}>
                      <Flex col={s} reverse={s}>
                        <Flex.Item
                          flex={1}
                          marginRight={valBySize(0, 4)}
                          marginTop={valBySize(4, 0)}
                        >
                          <RoundInfo />
                        </Flex.Item>
                        <Flex.Item
                          width={valBySize<string | number>('100%', 300, 400)}
                        >
                          <RoundForm />
                        </Flex.Item>
                      </Flex>
                    </Flex.Item>
                  </>
                )}
              </Content>
            )}
          </Container>
        </ContextModalProvider>
      )}
    </>
  );
};
